import { render, staticRenderFns } from "./JobOrdersTable.vue?vue&type=template&id=ced28fd8&scoped=true&"
import script from "./JobOrdersTable.vue?vue&type=script&lang=js&"
export * from "./JobOrdersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced28fd8",
  null
  
)

export default component.exports